import { httpClient } from '@/services/http/httpClient'

import type { FileType } from '@/types/fileType'

type UploadIdeaStepAttachmentProps = {
  files: FileType[]
  stepId: string
}

export const uploadIdeaStepAttachment = async ({
  files,
  stepId,
}: UploadIdeaStepAttachmentProps) => {
  const formData = new FormData()
  formData.append('stepId', stepId)

  files.forEach((file) => {
    if (file.file) {
      formData.append('files', file.file)
    }
  })

  await httpClient.post(
    `/ideas/funnel/steps/${stepId}/upload-attachments`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}
